var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousingProject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 63,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "housing-project_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 63
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .842h84v62H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#housing-project_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.505 23.02l-20.868-6.572a.268.268 0 00-.349.252l-.66 45.876a.268.268 0 00.26.272l21.528.657a.268.268 0 00.276-.268V23.275a.268.268 0 00-.187-.255z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.675 32.986v-9.757a.268.268 0 00-.184-.254l-22.046-7.196a.268.268 0 00-.351.254V62.57c0 .148.12.268.268.268h22.046c.148 0 .267-.12.267-.268V37.903",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.604 9.305l27.998.023-.943-3.286c-.115-.255-.453-.43-1.074-.43H16.382c-.116 0-.437.152-.57.385l-1.208 3.308z",
    fill: "#E5E5E5",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.424 55.661c.615 2.215 2.407 2.568 3.419 2.582 1.267.022 4.035-.446 3.89-4.782-.048-1.437-.32-2.89-.918-4.214-.39-.866-.934-1.766-1.74-2.35-.6-.435-1.326-.433-1.952-.04-.748.47-1.259 1.243-1.668 1.98-.688 1.238-1.056 2.626-1.19 4.014-.017.182-.03.365-.04.548-.014.229-.014.447-.014.656",
    fill: "#EEF8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.424 55.661c.615 2.215 2.407 2.568 3.419 2.582 1.267.022 4.035-.446 3.89-4.782-.048-1.437-.32-2.89-.918-4.214-.39-.866-.934-1.766-1.74-2.35-.6-.435-1.326-.433-1.952-.04-.748.47-1.259 1.243-1.668 1.98-.688 1.238-1.056 2.626-1.19 4.014-.017.182-.03.365-.04.548-.014.229-.014.447-.014.656M78.993 62.608v-4.237",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.406 51.845c-.106-1.6-.838-2.11-1.127-2.626-.41-.733 1.009-3.9-2.406-3.9s-2.059 3.175-2.407 3.9c-.294.616-1.138 1.14-1.138 2.95 0 2.768 2.24 3.589 3.545 3.589.936 0 2.35-.918 3.082-2.104",
    fill: "#BCE2B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.406 51.845c-.106-1.6-.838-2.11-1.127-2.626-.41-.733 1.009-3.9-2.406-3.9s-2.059 3.175-2.407 3.9c-.294.616-1.138 1.14-1.138 2.95 0 2.768 2.24 3.589 3.545 3.589.936 0 2.35-.918 3.082-2.104",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9 62.473V55.76v6.713z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9 62.473V55.76",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.748 9.186H12.019a.199.199 0 00-.199.198V62.641c0 .11.09.198.2.198h32.728c.11 0 .199-.089.199-.198V9.384a.199.199 0 00-.199-.198z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.826 17.721V9.384c0-.11.09-.198.2-.198h32.728c.11 0 .2.089.2.198V62.641c0 .11-.09.198-.2.198H12.025a.199.199 0 01-.199-.198V21.902",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.469 58.294c0-.653.53-1.183 1.182-1.183h9.295c.653 0 1.183.53 1.183 1.183v1.432h-11.66v-1.432z",
    fill: "#E5E5E5",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.281 61.218c0-.853.692-1.544 1.544-1.544H34c.853 0 1.544.691 1.544 1.544v.946H21.281v-.946z",
    fill: "#E5E5E5",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.828 47.121c0-.253.206-.459.46-.459h6.284c.254 0 .459.206.459.46v9.994h-7.203V47.12z",
    fill: "#F7FAFF",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.156 62.877h10.73c-.001-2.991-2.403-5.416-5.365-5.416-2.963 0-5.364 2.425-5.365 5.416z",
    fill: "#EEF8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.885 62.876c0-2.992-2.402-5.417-5.364-5.417-2.963 0-5.365 2.425-5.365 5.417",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.195 62.864c0-2.244-1.801-4.063-4.023-4.063-2.222 0-4.024 1.819-4.024 4.063h8.047z",
    fill: "#BCE2B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.195 62.866c0-2.244-1.801-4.063-4.023-4.063-2.222 0-4.024 1.819-4.024 4.063",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.962,
    transform: "matrix(-1 0 0 1 21.188 16.34)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.962,
    transform: "matrix(-1 0 0 1 21.188 25.88)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.962,
    transform: "matrix(-1 0 0 1 21.188 35.418)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.962,
    transform: "matrix(-1 0 0 1 29.578 16.34)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.962,
    transform: "matrix(-1 0 0 1 29.578 25.88)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.962,
    transform: "matrix(-1 0 0 1 29.578 35.418)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.962,
    transform: "matrix(-1 0 0 1 37.969 16.34)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.962,
    transform: "matrix(-1 0 0 1 37.969 25.88)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.962,
    transform: "matrix(-1 0 0 1 37.969 35.418)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.846,
    transform: "matrix(-1 0 0 1 56.773 25.88)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.846,
    transform: "matrix(-1 0 0 1 56.773 35.418)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.846,
    transform: "matrix(-1 0 0 1 56.773 35.418)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.846,
    transform: "matrix(-1 0 0 1 56.773 44.959)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.55,
    height: 3.578,
    rx: 0.846,
    transform: "matrix(-1 0 0 1 56.773 54.496)",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }))));
}
export default SvgHousingProject;